/**
 * Decision Rules Engine
 */

import { MonthStatus } from '@/lib/db/schema/simulations'
import { DecisionSignal } from '@/types'

export interface MonthStatusInput {
  netProfit: number
  endingEquity: number
  stopLossEquity: number
}

/**
 * Menentukan status untuk satu bulan simulasi.
 */
export function evaluateMonthStatus(input: MonthStatusInput): MonthStatus {
  if (input.endingEquity < 0) {
    return 'insolvent'
  }
  
  if (input.endingEquity <= input.stopLossEquity) {
    return 'stop_loss'
  }

  // Margin of safety 20% dari jarak antara stopLoss dan equity saat ini
  const safetyMargin = input.stopLossEquity * 1.2
  
  if (input.netProfit < 0) {
    if (input.endingEquity <= Math.max(0, safetyMargin)) {
      return 'critical'
    }
    return 'warning'
  }

  return 'healthy'
}

export interface DecisionSignalInput {
  totalMonths: number
  positiveProfitMonths: number
  finalEquity: number
  stopLossEquity: number
  isAboveBepFinalMonth: boolean
}

/**
 * Menentukan decision signal final dari keseluruhan simulasi.
 */
export function evaluateDecisionSignal(input: DecisionSignalInput): DecisionSignal {
  if (input.finalEquity <= input.stopLossEquity) {
    return 'close'
  }

  const profitRatio = input.positiveProfitMonths / input.totalMonths

  if (profitRatio === 0) {
    return 'pivot'
  }

  if (profitRatio < 0.5) {
    return 'restructure'
  }

  if (profitRatio < 0.8 || !input.isAboveBepFinalMonth) {
    return 'improve'
  }

  return 'continue'
}
